"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/isArrayLike.js
 ** module id = 249
 ** module chunks = 0
 **/